import React from 'react'
import { Box } from '@material-ui/core'
import Loader from 'react-loader-spinner'

const Loading = classes => {
  let color = '#f19012'
  if (classes !== null && classes !== undefined) {
    color = classes.colorPrimary
  }

  return (
    <Box
      display={'flex'}
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      className="full_height u-m-xsmall"
    >
      <Loader type="ThreeDots" color={color} height="150" width="160" />
    </Box>
  )
}

export default Loading
